import toast from 'react-hot-toast';

const FAVORITES_KEY = 'favoriteProducts';

// Ajouter un produit aux favoris
export const addToFavorites = (productId: string): boolean => {
    try {
        let favorites: string[] = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
        if (!favorites.includes(productId)) {
            favorites.push(productId);
            localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
            toast.success('Produit ajouté aux favoris', {
                duration: 1500,
                position: 'top-right',
                style: {
                    background: '#16f19e',
                    color: '#0A0A0A',
                    padding: '8px',
                    borderRadius: '8px',
                },
                iconTheme: {
                    primary: '#0A0A0A',
                    secondary: '#16f19e',
                },
            });
            window.dispatchEvent(new Event('favoritesUpdated'));
            return true;
        } else {
            toast('Déjà dans vos favoris', {
                duration: 1500,
                position: 'top-right',
                style: {
                    background: '#02cafd',
                    color: '#0A0A0A',
                    padding: '8px',
                    borderRadius: '8px',
                },
            });
            return false;
        }
    } catch (error) {
        console.error('Erreur ajout favoris:', error);
        toast.error('Erreur', {
            duration: 1500,
            position: 'top-right',
            style: {
                background: '#EF2535',
                color: '#ffffff',
                padding: '8px',
                borderRadius: '8px',
            },
        });
        return false;
    }
};

// Retirer un produit des favoris
export const removeFromFavorites = (productId: string): boolean => {
    try {
        let favorites: string[] = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
        if (favorites.includes(productId)) {
            favorites = favorites.filter(id => id !== productId);
            localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
            toast.success('Retiré des favoris', {
                duration: 1500,
                position: 'top-right',
                style: {
                    background: '#16f19e',
                    color: '#0A0A0A',
                    padding: '8px',
                    borderRadius: '8px',
                },
            });
            window.dispatchEvent(new Event('favoritesUpdated'));
            return true;
        }
        return false;
    } catch (error) {
        console.error('Erreur retrait favoris:', error);
        toast.error('Erreur', {
            duration: 1500,
            position: 'top-right',
            style: {
                background: '#EF2535',
                color: '#ffffff',
                padding: '8px',
                borderRadius: '8px',
            },
        });
        return false;
    }
};

// Basculer l'état favori
export const toggleFavorite = (productId: string): boolean => {
    const favorites: string[] = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
    if (favorites.includes(productId)) {
        return removeFromFavorites(productId);
    } else {
        return addToFavorites(productId);
    }
};

// Vérifier si un produit est favori
export const isFavoriteProduct = (productId: string): boolean => {
    try {
        const favorites: string[] = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
        return favorites.includes(productId);
    } catch {
        return false;
    }
};

// Compter les favoris
export const getFavoritesCount = (): number => {
    try {
        const favorites: string[] = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
        return favorites.length;
    } catch {
        return 0;
    }
};

export const getFavoritesIds = (): string[] => {
    try {
        return JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
    } catch {
        return [];
    }
};
